module.exports = __webpack_public_path__ + "img/40_28.509c52e2.png";